import React, { useEffect } from "react";
import { Button, Modal, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  Delete,
  Save as SaveIcon,
  Close as CloseIcon,
} from "@mui/icons-material";

import Input from "components/Input";

import { useAppDispatch } from "store/hooks";

import {
  handleUpdateBrandRequest,
  handleUpdateCategorieRequest,
} from "store/modules/Catalog/thunk.store";
import * as Styled from "./styles";

interface AddNewData {
  name: string;
  description: string;
  id: string;
}

interface AddNewModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  update?: any;
}

const UpdateCatalogModal: React.FC<AddNewModalProps> = ({
  isOpen,
  title,
  update,
  onClose,
}) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm<AddNewData>({
    defaultValues: {
      name: update?.data?.name,
      description: update?.data?.description,
      id: update?.data?.id,
    },
  });

  const dispatch = useAppDispatch();

  const handleSubmitForm = async (data: AddNewData) => {
    if (title === "Categoria") {
      await dispatch(
        handleUpdateCategorieRequest({
          data: {
            name: data.name,
            description: data.description,
          },
          id: data.id,
        }),
      ).unwrap();
    }
    if (title === "Marca") {
      await dispatch(
        handleUpdateBrandRequest({
          data: {
            name: data.name,
            description: data.description,
          },
          id: update.data.id,
        }),
      ).unwrap();
    }

    onClose();
  };

  useEffect(() => {
    reset();
  }, [isOpen, reset]);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Styled.Content>
        <Typography variant="h6" mb={2}>
          {`Adicionar ${title}`}
        </Typography>

        <Styled.TypeLinkContainer onSubmit={handleSubmit(handleSubmitForm)}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                name="name"
                error={errors.name}
                label={`Nome da  ${title}`}
                register={register}
                defaultValue={update?.data?.name || ""}
                fullWidth
                registerOptions={{
                  required: t("requiredField"),
                }}
                sx={{ mb: 2 }}
              />
            )}
          />

          <Input
            name="description"
            defaultValue={update?.data?.description}
            error={errors.description}
            label={`${t("description")} ${t("of")}  ${title}`}
            register={register}
            fullWidth
            registerOptions={{
              required: t("requiredField"),
            }}
            sx={{ mb: 2 }}
          />

          <Styled.ActionsContainer>
            <Button
              color="secondary"
              variant="text"
              onClick={onClose}
              endIcon={<CloseIcon />}
            >
              {t("close")}
            </Button>

            <Button
              onClick={() => ""}
              color="primary"
              variant="text"
              endIcon={<Delete />}
            >
              {t("delete").toUpperCase()}
            </Button>

            <Button variant="text" type="submit" endIcon={<SaveIcon />}>
              {t("save")}
            </Button>
          </Styled.ActionsContainer>
        </Styled.TypeLinkContainer>
      </Styled.Content>
    </Modal>
  );
};

export default UpdateCatalogModal;
